import { z } from 'zod';
import { tradeSchema } from './ITrade';
import { professionProjectPropertiesSchema } from './IProfessionProjectProperties';

// Schemas (source of truth)
export const baseProfessionSchema = tradeSchema.extend({
	projectId: z.string(),
	organizationId: z.string(),
	activeProjects: z.record(z.string(), professionProjectPropertiesSchema),
	contractor: z.string().optional(),
	specialty: z.string().optional(),
});

// Types (derived from schemas)
export type IBaseProfession = z.infer<typeof baseProfessionSchema>;
